import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: 'relative z-10 flex max-w-max flex-1 items-center justify-center',
  },
  styles: {
    root: {},
  },
}));
